// Ytelsesvei for flere klare kjopsbilag. Lastes etter backend-receipt-inbox.jsx
// og deler det klassiske bindingsmiljoet med resten av backend-tjenestene.
const tryBookReadyReceiptInboxEntriesBatch = async (plannedEntries = [], selectedPaymentAccount = '') => {
  const booked = [];
  let remaining = [...plannedEntries];
  if (selectedPaymentAccount || remaining.length < 2) return { booked, remaining };
  try {
    const queue = await getAutopilotTaskQueue({ preferCache: true });
    const selectedIds = new Set(remaining.map((item) => item.id));
    const batchTasks = safeArray(queue).filter((task) => task?.type === 'receipt_bookkeeping'
      && selectedIds.has(task?.sourceId)
      && ['ready', 'approved'].includes(task?.status));
    if (batchTasks.length < 2) return { booked, remaining };
    const result = await approveAndBookAutopilotTasks({
      readyTaskIds: batchTasks.filter((task) => task.status === 'ready').map((task) => task.id),
      approvedTaskIds: batchTasks.filter((task) => task.status === 'approved').map((task) => task.id),
    });
    const executed = new Set(safeArray(result?.executed));
    const bookedIds = new Set(batchTasks.filter((task) => executed.has(task.id)).map((task) => task.sourceId));
    booked.push(...remaining.filter((item) => bookedIds.has(item.id)));
    remaining = remaining.filter((item) => !bookedIds.has(item.id));
    bookedIds.forEach((entryId) => {
      const entry = receiptInboxBackendEntries().find((candidate) => candidate.id === entryId);
      if (!entry) return;
      const analysis = entry.receiptAnalysis || {};
      const purchase = safeArray(runtime.appState?.expenses).find((candidate) => candidate.id === entry.linkedEntryId);
      queueAiLearningLog(() => logReceiptSuggestionOutcome({
        entry,
        outcome: 'booked',
        finalChoice: {
          receiptInboxEntryId: entry.id,
          bookedAs: entry.bookedAs || 'expense',
          linkedEntryId: entry.linkedEntryId,
          userChangedFields: safeArray(analysis.userEditedFields),
          documentType: analysis.documentType,
          postingType: analysis.suggestedPostingType,
          paymentSource: purchase?.paidBy || analysis.suggestedPaymentSource,
          paymentAccountCode: purchase?.paymentAccountCode || purchase?.settlementAccountCode || analysis.paymentAccountCode,
          accountCode: purchase?.costAccountCode || analysis.suggestedCostAccountCode,
          vatRate: purchase?.vatRate ?? analysis.vatRate,
          reverseChargeCode: purchase?.reverseChargeCode || analysis.reverseChargeCode,
          supplierName: purchase?.supplierName || analysis.supplierName,
        },
      }), { sourceType: 'receipt_inbox', sourceId: entry.id, outcome: 'booked' });
    });
  } catch (error) {
    // Batch er en ytelsesvei. Ved konkurrerende endring eller gammel backend
    // faller vi tilbake til den etablerte per-bilag-flyten med samme resultat.
    console.warn('Atomisk bilagsbatch var ikke tilgjengelig; bruker trygg fallback.', error);
  }
  return { booked, remaining };
};
